let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6kBt0")).then(() => parcelRequire('l66zA'));